import React from 'react';
import {
  Button,
  Dialog,
  Stack,
  Typography,
} from '@mui/material';
import { solidButtonSx, textButtonSx } from '../styles';

export interface TooManyAttemptsModalProps {
  open: boolean;
  onBackToSignIn: () => void;
}

const TooManyAttemptsModal = ({
  open,
  onBackToSignIn,
}: TooManyAttemptsModalProps): React.ReactElement => {
  const handleCallSupport = () => {
    window.open('tel:8884412418', '_blank');
  };

  return (
    <Dialog
      open={open}
      onClose={() => undefined}
      disableEscapeKeyDown
      maxWidth={false}
      aria-labelledby="too-many-attempts-title"
      aria-describedby="too-many-attempts-description"
      PaperProps={{
        sx: {
          width: { xs: '100%', md: 480 },
          maxWidth: 480,
          maxHeight: 'calc(100vh - 64px)',
          m: 2,
          overflowY: 'auto',
          borderRadius: 0,
          backgroundColor: '#FAF6F2',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.18)',
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: 'rgba(0, 0, 0, 0.45)',
        },
      }}
    >
      <Stack
        spacing={2}
        alignItems="center"
        textAlign="center"
        sx={{
          boxSizing: 'border-box',
          p: 4,
        }}
      >
        <Typography
          id="too-many-attempts-title"
          component="h2"
          sx={{
            fontFamily: 'Satoshi, sans-serif',
            fontWeight: 500,
            fontSize: '28px',
            lineHeight: '40px',
            letterSpacing: 0,
            color: '#070707',
          }}
        >
          Too Many Attempts
        </Typography>

        <Typography
          id="too-many-attempts-description"
          variant="body1"
          color="text.secondary"
          sx={{
            pb: 6,
          }}
        >
          For your security, this code can no longer be used. Go back and request a
          new one to continue.
        </Typography>

        <Stack spacing={2} alignItems="center" width="100%">
          <Button
            variant="contained"
            fullWidth
            onClick={onBackToSignIn}
            sx={solidButtonSx}
          >
            Back to Sign In
          </Button>

          <Button
            variant="text"
            fullWidth
            onClick={handleCallSupport}
            sx={textButtonSx}
          >
            Need Help? Call us at 888 441-2418.
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export default TooManyAttemptsModal;
